import { SVGProps } from 'react';
import { tokens } from '../../core/theme';

type SuitcaseIconProps = SVGProps<SVGSVGElement> & { color?: string };

export const SuitcaseIcon = ({
  width = 24,
  height = 24,
  color = tokens.colors.brand.red.DEFAULT,
  ...props
}: SuitcaseIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.17954 6.99805H17.8204C19.5785 6.99805 21.0037 8.42327 21.0037 10.1814V18.0026C21.0037 19.6602 19.66 21.0039 18.0025 21.0039H5.99747C4.33992 21.0039 2.99622 19.6602 2.99622 18.0026V10.1814C2.99622 8.42327 4.42144 6.99805 6.17954 6.99805Z"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.0037 10.9995C16.0311 13.6673 7.96885 13.6673 2.99622 10.9995"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99829 8.99908V4.99742C7.99829 3.89239 8.89409 2.99658 9.99912 2.99658H14.0008C15.1058 2.99658 16.0016 3.89239 16.0016 4.99742V8.99908"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5006 17.0022H10.4994"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
